<template>
  <div id="vue-app">
      <div class="container mt">
      <div class="form-container" v-if="!loggedIn">
        <div tabindex="0" role="alert" class="error-container" id="error">
            <div class="error" v-if="error">
                <p>Login Attempt Failed: Please check your username and password.</p>
            </div>
        </div>

        <div tabindex="0" role="alert" class="confirm-container" id="verificationConfirm">
          <div class="verification" v-if="verificationMessage">
              <p>Your email has been verified! You can now login.</p>
          </div>
        </div>
        <div tabindex="0" role="alert" class="error-container" id="verificationError">
          <div class="error verificationError" v-if="verificationError">
              <p>There was a problem with your email verification. Please contact us at 513-621-3000.</p>
          </div>
        </div>
        <div tabindex="0" role="alert" class="error-container" id="applicationError">
          <div class="verification" v-if="applicationMessage">
              <p>Looks like there was a problem authenticating your account. Please log back in.</p>
          </div>
        </div>
          <form id="loginForm">
                <label for="username">Username</label>
                <input type="text" class="" name="username" id="username" v-model="username">
                <label for="password">Password</label>
                <input type="password" class="" name="password" id="password" v-model="password">
            </form>
            <button v-on:click="login">Submit</button>
            <double-bounce v-if="loggingIn"></double-bounce>
            <router-link to="/available-properties/send-reset-password/">Forgot password?</router-link>
            <router-link to="/available-properties/register/">Don't have an account? Sign Up!</router-link>
        </div>

        <div class="loggedin-container" v-if="loggedIn">
            <div class="">
                <p>Looks like you're already logged in!</p>
                <div class="button-container">
                    <button class="btn btn-primary btn-xs" v-on:click="logout">Available Properties</button>
                    <button class="btn btn-primary btn-xs" v-on:click="logout"><i class="fas fa-user-alt" style="margin-right:.5rem;"></i>Logout</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';


export default {
  name: 'ApplicationLogin',
 components: {
    DoubleBounce,
  },
  data() {
    return {
        username: '',
        password: '',
        error: false,
        verificationMessage: false,
        verificationError: false,
        applicationMessage: false,
        title: 'Login',
        loggingIn: false,
        loggedIn: this.$store.state.loggedIn
    }
  },
  created() {
    window.scrollTo(0,0);
      // Check if this is a redirect from email verification    
      if (this.$route.query.verified == 'true') {
          this.$set(this, 'verificationMessage', true);
           window.scrollTo(0,0);
            document.getElementById('verificationConfirm').focus();

      } 
    //   else if (this.$route.query.verified) {
    //       this.$set(this, 'verificationError', true);
    //       window.scrollTo(0,0);
    //         document.getElementById('verificationError').focus();
    //   }

    // Check if this is an application error redirect 
      if (this.$route.query.fromApplication) {
          axios.post('/wp-json/HCLRC/v1/public-user-logout/'
            ).then(res => {
                this.$store.commit('logout');
            })
            .catch(function (error) {
                // if an error occurs, print that error
                console.log(error);

            });
            this.$set(this, 'applicationMessage', true);
      }      

  },
  methods: {
      login() {
          this.$set(this, 'loggingIn', true);
          axios.post('/wp-json/HCLRC/v1/public-user-login', {
            userEmail: this.username, userPassword: this.password
            }).then(res => {
                if (res.data.loggedIn) {
                    this.$store.commit('login', res.data.token);
                    var redirect = this.getRedirect();
                    if (redirect == '/available-properties') {
                        window.location.href = redirect;

                    }

                    if (redirect) {
                        this.$router.push(redirect)
                    } else {
                        window.location.href = '/available-properties/applications/';
                    }
                    
                } else {
                    this.$set(this, 'error', true);
                    this.$set(this, 'loggingIn', false);
                    window.scrollTo(0,0);
                    document.getElementById('error').focus();

                    
                }
            
        })
        .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);

        });
      },
      getRedirect() {
            if (this.$route.query.redirect !== undefined) {
                return decodeURIComponent(this.$route.query.redirect);
            }
            // if (window.location.search != '') {
            //     var queries = window.location.search.substring(1);
            //     if (queries.includes('redirect=')) {
            //         var queryItems = queries.split('&');
            //         var redirect;
            //         for (var item of queryItems) {
            //             var keyValuePair = item.split("=");
            //             if (keyValuePair[0] == 'redirect') {
            //                 return decodeURIComponent(keyValuePair[1]);
            //             }
            //         }
            //     }
            // }
            return false;
      },
      logout() {
        this.$parent.logout();
      },
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.error {
    background-color: #dc3b43;
    padding: 1rem;
    margin-bottom: 2rem;
    p {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
    }
}
.verification {
    border: 3px solid rgba(37, 114, 130, .3);
    padding: .5rem;
    text-align: center;
    margin-bottom: 2rem;
    p {
        margin-bottom: 0;
        font-weight: 700;
    }
}
.form-container {
    text-align: center;
    form {
        display: flex;
        flex-direction: column;
        width: 40%;
        margin: 0 auto;
        label {
            font-weight: 600;
            margin-bottom: 0;
            text-align: left;
        }
        input {
            font-family: "neue-haas-unica";
            border: 1px solid rgba(37, 114, 130, .3);
            margin-bottom: 1rem;
            font-size: 1rem;
        }
        @media screen and (max-width: 992px) {
            width: 100%;
        }
    }
    button {
        font-size: 1.25rem;
        font-family: 'din-2014';
        font-weight: 600;
        padding: .75rem 5rem;
        background-color: #dc3b43;
        color: #fff;
        font-size: 1rem;
        margin-bottom: 1rem;
        cursor: pointer;
        transition: all .5s;

        &:hover, &:focus, &.active {
            background-color: #A12127;
        }
    }
    a {
        display: block;
        text-transform: none;
        color: #dc3b43;
    }
    .spinner {
        margin-bottom: 0 !important;
        margin-top: .25rem;
        margin-left: .5rem;
        position: absolute !important;
    }
}
.loggedin-container {
    .button-container {
        margin-top: 2rem;
        button {
            margin-right: 1rem;
        }
    }
    text-align: center;
    margin-bottom: 2rem;
    p {
        margin-bottom: 0;
        font-weight: 700;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationLogin.vue